<template>
  <div class="io-slider">
    <Slider
      v-model="value"
      :min="min"
      :max="max"
      :step="step"
      :tooltips="tooltip"
      :show-tooltip="tooltipShow"
      :format="tooltipFormat"
      @change="emitChange"
    />
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
} from 'vue';

import Slider from '@vueform/slider';

export default defineComponent({
  components: {
    Slider,
  },

  props: {
    modelValue: {},
    min: {
      type: Number,
      required: false,
      default: () => 0,
    },
    max: {
      type: Number,
      required: false,
      default: () => 100,
    },
    step: {
      type: Number,
      required: false,
      default: () => 1,
    },
    tooltip: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    tooltipFormat: {
      type: [Object, Function],
      required: false,
    },
    tooltipShow: {
      type: String,
      required: false,
      default: () => 'always',
    },
  },

  emits: [
    'update:modelValue',
    'change',
    'input',
  ],

  setup(props, context) {
    const value = computed({
      get(): unknown {
        return props.modelValue;
      },
      set(newValue: unknown): void {
        context.emit('update:modelValue', newValue);
      },
    });

    const emitChange = (val: number) => {
      context.emit('change', val);
    };

    return {
      value,
      emitChange,
    };
  },
});
</script>

<style lang="scss">
@import '~@vueform/slider/themes/default';
@import 'src/scss/component-helpers';

.io-slider {
  --slider-bg: #DBDBDB;
  --slider-connect-bg: var(--icon-color-active, var(--color-brand-primary));
  --slider-connect-bg-disabled: #9CA3AF;
  --slider-height: 4px;
  --slider-vertical-height: 300px;
  --slider-radius: 9999px;

  --slider-handle-bg: #fff;
  --slider-handle-border: 0;
  @include responsive-size-sm(20, ---slider-handle-width);
  @include responsive-size-sm(20, ---slider-handle-height);
  --slider-handle-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, .32);
  --slider-handle-shadow-active: 0.5px 0.5px 2px 1px rgba(0, 0, 0, .42);
  --slider-handle-ring-width: 3px;
  --slider-handle-ring-color: #DBDBDB;

  --slider-tooltip-bg: var(--icon-color-active, var(--color-brand-primary));
  --slider-tooltip-color: #fff;
  --slider-tooltip-radius: 7px;
  --slider-tooltip-min-width: 1em;
  --slider-tooltip-line-height: 1.2;
  --slider-tooltip-font-weight: 600;
  --slider-tooltip-py: .5em;
  --slider-tooltip-px: 1em;
  --slider-tooltip-arrow-size: .33333em;
  --slider-tooltip-distance: .33333em;

  .slider-tooltip {
    @include font-small;
    @include poppins;
  }
}
</style>
